import { Button, Input } from "antd";
import qs from "query-string";
import React, { useState } from "react";
import { useHistory } from "react-router";
import BankFeedsCommonLayout from "../../components/bankFeeds/layout";

const SageBankFeedsFakeLogin: React.FC = () => {
  const history = useHistory();
  const { search } = history.location;
  const { challenge } = qs.parse(search);

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const handleCompleteSubmit = async () => {
    const redirectUriWithPassword = `/sage_bank_feeds_redirect?challenge=${challenge}&otp=${password}`;
    window.location.replace(redirectUriWithPassword);
  };

  return (
    <BankFeedsCommonLayout name={"OAUTH BANK LOGIN PAGE"}>
      <div className="mt-2">
        <Input
          placeholder="Username"
          value={username}
          title="Username"
          onChange={(e) => setUsername(e.target.value)}
        />
        <Input
          placeholder="Password"
          type="password"
          value={password}
          title="Password"
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <Button
        className="mt-3"
        type="primary"
        block
        disabled={!password || !username}
        onClick={handleCompleteSubmit}
      >
        Submit
      </Button>
    </BankFeedsCommonLayout>
  );
};

export default SageBankFeedsFakeLogin;
